import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <g>
                    <path d="M34.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S5.4,99.8,8,104.5s10.7,5.4,18,1.6S36.9,95.4,34.2,90.7Z" />
                    <rect x="33.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <g>
                    <path d="M98.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S69.4,99.8,72,104.5s10.7,5.4,18,1.6S100.9,95.4,98.2,90.7Z" />
                    <rect x="97.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <rect x="33" y="23" width="66" height="10" />
            </g>
        </svg>
    );
}
